var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPublic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8805 4.20688C15.7377 4.05753 12.3026 0.544922 8.00002 0.544922C3.69745 0.544922 0.262328 4.05753 0.119484 4.20688C-0.0398281 4.37382 -0.0398281 4.62618 0.119484 4.79312C0.262328 4.94247 3.69752 8.45508 8.00002 8.45508C12.3025 8.45508 15.7377 4.94247 15.8805 4.79312C16.0398 4.62618 16.0398 4.37382 15.8805 4.20688ZM8.00002 7.57617C6.19092 7.57617 4.71877 6.19603 4.71877 4.5C4.71877 2.80397 6.19092 1.42383 8.00002 1.42383C9.80911 1.42383 11.2813 2.80397 11.2813 4.5C11.2813 6.19603 9.80911 7.57617 8.00002 7.57617Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 3.62109C8.46875 3.179 8.70284 2.79009 9.05897 2.55088C8.73941 2.39751 8.38297 2.30273 8 2.30273C6.70772 2.30273 5.65625 3.28849 5.65625 4.5C5.65625 5.71151 6.70772 6.69727 8 6.69727C9.157 6.69727 10.1146 5.90525 10.3038 4.87037C9.35987 5.15528 8.46875 4.486 8.46875 3.62109Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPublic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/public.071e4b02.svg";
export { ForwardRef as ReactComponent };